module.exports = __webpack_public_path__ + "arrow-right.svg?b8b44b8da6986790ae36071d1edf9dca";